import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import { Carousel as CPCarousel } from './carousel';

export const Carousel = styled(CPCarousel)`
  ${({ theme: { colors } }) => `
    background-color: ${colors.greys.greys5};
  `}
`;

export const LocationContainer = styled(Grid)`
  ${({ theme: { breakpoints } }) => `
    flex-direction: column;
    padding-bottom: 12px;

    ${breakpoints.up('md')} {
      flex-direction: row;
    }
  `}
`;

export const LeftSide = styled(Box)`
  ${({ theme: { breakpoints } }) => `
    padding-right: 0;

    ${breakpoints.up('md')} {
      padding-right: 55px;
    }
  `}
`;

export const Content = styled(Box)`
  ${({ theme: { colors, breakpoints } }) => `
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${colors.greys.greys3};

    ${breakpoints.up('md')} {
      margin-bottom: 40px;
      padding-bottom: 50px;
    }
  `}
`;

export const ItemMap = styled(Grid)`
  ${({ theme: { breakpoints } }) => `
   

    ${breakpoints.up('md')} {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  `}
`;
